<div id="integrationItem" class="modal fade" aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    Sincronizar itens com o ERP
                </h4>        
            </div>
            <div class="modal-body">
                <form #form="ngForm" novalidate>
                    <div class="row">
                        <div class="form-group col-12">
                            <label for="integrationItemPeriodicidade" class="col-form-label">Periodicidade</label>
                            <select class="form-control" name="integrationItemPeriodicidade" id="integrationItemPeriodicidade" 
                                [ngModel]="entity.periodicidade || ''" (ngModelChange)="entity.periodicidade = $event ? $event : null"
                                #integrationItemPeriodicidade="ngModel" required="required">
                                <option *ngFor="let periodicidade of periodicidades" [ngValue]="periodicidade.id">{{getDescricaoPeriodicidade(periodicidade.id)}}</option>
                            </select>  
                            <p class="form-text text-muted">Periodicidade da sincronização dos itens</p>
                            <sgt-form-control-error
                                *ngIf="integrationItemPeriodicidade.errors && integrationItemPeriodicidade.errors.required && integrationItemPeriodicidade.dirty"
                                msgError="A periodicidade é obrigatória">
                            </sgt-form-control-error>                                       
                        </div>                        
                    </div> 

                    <!-- Geral -->
                    <div class="row" *ngIf="isPeriodicidadeGeral()">
                        <div class="col-12">
                            <div class="row">
                                <div class="form-group col-12">
                                    <label class="col-form-label" for="integrationItemDataCadastroBase">Data de Cadastro Inicial</label>
                                    <sgt-datepicker [(ngModel)]="entity.dataCadastroBase" name="integrationItemDataCadastroBase" id="integrationItemDataCadastroBase"
                                        #integrationItemDataCadastroBase="ngModel" [ngControl]="integrationItemDataCadastroBase" required="required">
                                    </sgt-datepicker>
                                    <p class="form-text text-muted">Irá sincronizar os itens cadastrados a partir desta data</p>
                                    <sgt-form-control-error
                                        *ngIf="integrationItemDataCadastroBase.errors && integrationItemDataCadastroBase.errors.required && integrationItemDataCadastroBase.dirty"
                                        msgError="A data inicial é obrigatória">
                                    </sgt-form-control-error>  
                                </div>                         
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="alert alert-warning" role="alert">
                                        <i class="fas fa-exclamation-triangle" aria-hidden="true"></i> Atenção! Se você informar uma data de cadastro inicial muito antiga a sincronização pode levar vários minutos.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>  
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" (click)="execute()" [disabled]="form.invalid">
                    Sincronizar
                </button>              
                <button type="button" class="btn btn-light" (click)="close()">
                    Cancelar
                </button>
            </div>            
        </div>
    </div>
</div>